// Force webpack rebuild for breadcrumb deployment
import React, { useCallback, useEffect, useState } from 'react';

import { SbCurrentUser } from '../submission_boards/component/SbModel';
import { useIsBreakPoint, useIsMobile } from '../submission_boards/component/useIsMobile';
import { HmuKitDocumentModel } from '../submission_kits/components/KitModels';
import hmuKitService from '../services/HmuKitService';
import userService from '../services/UserService';
import { showToast } from '../shared/Toast';
import { ProfileHeader } from './ProfileHeader';
import { HairMakeupKit } from './HairMakeupKit';
import { KitsPages } from './ProfileModal';
import { WardrobeKit } from './WardrobeKit';
import { WorkKit } from './WorkKit';
import { SubmissionKitPage } from './SubmissionKitPage';
import { useMedia } from 'react-use';
import { About } from './About';
import { ChevronDown } from 'lucide-react';
import Breadcrumb from '../shared/Breadcrumb';
import usePageTracking from '../shared/UsePageTracking';

export interface ProfilePageProps {
  currentUser: SbCurrentUser;
  user: any;
  projects: any;
  project: any;
  submissionBoardModel: any;
  project_folder: any;
  project_user: any;
  project_folder_user: any;
  show_add_sb_button: any;
  from: any;
}
export default function ProfilePage({
  currentUser,
  user,
  projects,
  project,
  submissionBoardModel,
  project_folder,
  project_user,
  project_folder_user,
  show_add_sb_button,
  from,
}: ProfilePageProps) {
  // Helper function to get initial kit from URL params
  const getInitialKit = (): KitsPages => {
    if (typeof window === 'undefined') return KitsPages.about;

    const searchParams = new URLSearchParams(window.location.search);
    const tab = searchParams.get('tab') || 'about';
    const tabMapping: Record<string, KitsPages> = {
  'about': KitsPages.about,
  'work_kits': KitsPages.workkit,
  'workkit': KitsPages.workkit,  // mobile version
  'submission_kits': KitsPages.skit,
  'submissionkit': KitsPages.skit,  // mobile version
  'hair_make_up_kits': KitsPages.hairmakeupkit,
  'hairmakeupkit': KitsPages.hairmakeupkit,  // mobile version
  'wardrobe_kits': KitsPages.wardrobekit,
  'wardrobekit': KitsPages.wardrobekit,  // mobile version
};

    return tabMapping[tab] || KitsPages.about;
  };
  // const isMobile = useIsMobile();
  const { isMobile, isLg1100 } = useIsBreakPoint();
  const widthFinal = isLg1100 ? '68.75rem' : '100%';
  const [showTopProfileHeader, setShowTopProfileHeader] = useState(true);
  // const isLg = useMedia('(min-width: 1100px)', false);
  // const [hmuKitDocuments, setHmuKitDocuments] = useState<HmuKitDocumentModel[]>([]);
  const [featured, setFeatured] = useState(0);
  const [kits, setKits] = useState(getInitialKit());
  const [isAboutExpanded, setIsAboutExpanded] = useState<boolean>(true);


  const [loading, setLoading] = useState(false);
  const [profileUser, setProfileUser] = useState(user);

  let pageTitle = kits;
  usePageTracking(pageTitle);

  useEffect(() => {
    if (from === 'public' && user?.uuid) {
      fetchPublicProfile(user.slug || user.uuid);
    }
  }, [from, user]);

  const fetchPublicProfile = async (slugOrId: string) => {
    try {
      if (!profileUser) setLoading(true);
      const data = await userService.getPublicProfile(slugOrId);
      if (data.success) {
        setProfileUser(data.user);
      }
    } catch (error) {
      console.error('Error fetching public profile:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(
      'ProfilePage: currentUser',
      currentUser,
      'ProfilePage: user',
      profileUser,
      'ProfilePage: projects',
      projects,
      'ProfilePage: project',
      project,
      'ProfilePage: project_user',
      project_user,
      'ProfilePage: project_folder_userv',
      project_folder_user,
      'ProfilePage: show_add_sb_button',
      show_add_sb_button,
      'ProfilePage: from',
      from
    );
    handleLocationParam();
  }, [profileUser]);

  useEffect(() => {
    const handlePopState = (event) => {
      handleLocationParam();
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  const handleLocationParam = () => {
    const queryParams = getUrlFilter();
    if (queryParams.tab != '') {
      switch (queryParams.tab) {
        case 'about':
          setKits(KitsPages.about);
          break;
        case 'work_kits':
          if(user?.work_kit != undefined && Object.keys(user.work_kit).length > 0 ) {
            setKits(KitsPages.workkit);
          } else {
            setKits(KitsPages.about);
          }
          break;
        case 'submission_kits':
          if(user?.submission_kit_profile != undefined && Object.keys(user.submission_kit_profile).length > 0 ) {
          setKits(KitsPages.skit);
          } else {
            setKits(KitsPages.about);
          }
          break;
        case 'hair_make_up_kits':
          if((user?.show_hair_makeup_kit ?? true) && user?.hair_make_up_kit != undefined && Object.keys(user.hair_make_up_kit).length > 0 ) {
          setKits(KitsPages.hairmakeupkit);
          } else {
            setKits(KitsPages.about);
          }
          break;
        case 'wardrobe_kits':
          if((user?.show_wardrobe_kit ?? true) && user?.wardrobe_kit != undefined && Object.keys(user.wardrobe_kit).length > 0 ) {
          setKits(KitsPages.wardrobekit);
          } else {
            setKits(KitsPages.about);
          }
          break;

        default:
          break;
      }
    }
  }
  const getUrlFilter = () => {
    if (typeof window === 'undefined') return {
      tab: 'about'
    };
    const searchParams = new URLSearchParams(window.location.search);
    const tab = searchParams.get('tab') || 'about';

    return { tab: tab };
  };
  // const fetchHmuKitDocuments = async () => {
  //   try {
  //     // setIsLoading(true);
  //     const response = await hmuKitService.getHmuKitDocuments();
  //     if (response.status === 'success') {
  //       //wardrobeKitDoc.kit_document.id
  //       response.hmu_kit_documents.map((item) => {
  //         if (item.tag && item.tag == '1') {
  //           setFeatured(item.kit_document.id);
  //         }
  //       });
  //       setHmuKitDocuments(response.hmu_kit_documents || []);
  //     }
  //   } catch (error) {
  //     showToast('Error fetching Hair & Make-up Kit photos.', 'danger');
  //   } finally {
  //     // setIsLoading(false);
  //   }
  // };
  const updateUrl = useCallback((selectedKit) => {
    if (typeof window !== 'undefined' && window.history.pushState) {
      const url = new URL(window.location.href);
      let newTabValue = 'about';
      switch (selectedKit) {
        case KitsPages.about:
          newTabValue = 'about';
          break;
        case KitsPages.workkit:
          newTabValue = 'work_kits';
          break;
        case KitsPages.hairmakeupkit:
          newTabValue = 'hair_make_up_kits';
          break;
        case KitsPages.skit:
          newTabValue = 'submission_kits';
          break;
        case KitsPages.wardrobekit:
          newTabValue = 'wardrobe_kits';
          break;
        default:
          break;
      }
      url.searchParams.set('tab', newTabValue);
      const newUrl = url.toString();
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  }, []);

  // Build breadcrumb pages
  const getBreadcrumbPages = () => {
    console.log('getBreadcrumbPages called with from:', from, 'project:', project, 'project_folder:', project_folder);
    const pages = [];

    if (project && project_folder) {
      // Add Project
      pages.push({
        name: project.title,
        href: `/projects/${project.uuid}`,
        current: false,
      });

      // Add Project Folder (Team)
      pages.push({
        name: project_folder.formatted_name || project_folder.name || 'Team',
        href: `/projects/${project.uuid}/project_folders/${project_folder.uuid}`,
        current: false,
      });

      // Add User - show name if available, otherwise show email
      const userName = user.first_name && user.last_name
        ? `${user.first_name} ${user.last_name}`.trim()
        : user.email;

      pages.push({
        name: userName,
        href: '#',
        current: true,
      });
    } else if (from === 'directory') {
      // Coming from directory
      pages.push({
        name: 'Directory',
        href: '/users/directory',
        current: false,
      });

      // Add User - show name if available, otherwise show email
      const userName = user.first_name && user.last_name
        ? `${user.first_name} ${user.last_name}`.trim()
        : user.email;

      pages.push({
        name: userName,
        href: '#',
        current: true,
      });
    } else if (currentUser && currentUser.uuid === user.uuid) {
      // Viewing your own profile - breadcrumb is handled by ERB template
      // Don't add pages here to avoid duplicate breadcrumb
    } else {
      // Viewing someone else's profile without context - no breadcrumb needed
      // pages remain empty
    }

    return pages;
  };

  const breadcrumbPages = getBreadcrumbPages();
  return (
    <div className="w-full flex flex-col flex-1 mx-auto bg-grayish-blue">
      {breadcrumbPages.length > 0 && <Breadcrumb pages={breadcrumbPages} />}
      <div
        className="sm:mx-auto pb-8 sm:py-4 px-2 sm:px-0 gap-4 flex flex-col"
        style={{
          maxWidth: isMobile?'auto': '68.75rem', // 1100
          width: widthFinal,
        }}
      >
        {/* Loading state - only shown if no user data is available */}
        {loading && !profileUser && <div className="text-center py-10">Loading profile...</div>}
        
        {/* Header - shown if profileUser exists, regardless of background loading */}
        {showTopProfileHeader && profileUser && (
          <ProfileHeader
            currentUser={currentUser}
            user={profileUser}
            selectedKit={kits} 
            menuAction={function (selectedKit: KitsPages): void {
              setKits(selectedKit);
              updateUrl(selectedKit)
            }}
            show_add_sb_button={show_add_sb_button}
            projects={projects}
            project={project}
            submissionBoardModel={submissionBoardModel}
            project_user={project_user}
            project_folder_user={project_folder_user}
            from={from}
          />
        )}
        {kits == KitsPages.about && !profileUser?.is_prod_support_onboarding && profileUser && (
          <>
            <About
              currentUser={currentUser}
              user={profileUser}
              showProfileHeader={function (show): void {
                setShowTopProfileHeader(show);
              }}
            />
          </>
        )}

        {(profileUser?.show_hair_makeup_kit ?? true) && kits == KitsPages.hairmakeupkit && !profileUser?.is_prod_support_onboarding && profileUser && (
          <HairMakeupKit
            currentUser={currentUser}
            user={profileUser}
            showProfileHeader={function (show): void {
              setShowTopProfileHeader(show);
            }}
          />
        )}
        {(profileUser?.show_wardrobe_kit ?? true) && kits == KitsPages.wardrobekit && !profileUser?.is_prod_support_onboarding && profileUser && (
          <WardrobeKit
            currentUser={currentUser}
            user={profileUser}
            showProfileHeader={function (show): void {
              setShowTopProfileHeader(show);
            }}
          />
        )}

        {kits == KitsPages.workkit && !profileUser?.is_prod_support_onboarding && profileUser && (
          <WorkKit
            currentUser={currentUser}
            user={profileUser}
            from={from}
            showProfileHeader={function (show): void {
              setShowTopProfileHeader(show);
            }}
          />
        )}

        {kits == KitsPages.skit && !profileUser?.is_prod_support_onboarding && profileUser && (
          <SubmissionKitPage
            currentUser={currentUser}
            user={profileUser}
            projects={projects}
            project={project}
            project_user={project_user}
            project_folder_user={project_folder_user}
            show_add_sb_button={show_add_sb_button}
            from={from}
            showProfileHeader={function (show): void {
              setShowTopProfileHeader(show);
            }}
          />
        )}
      </div>
    </div>
  );
}
